import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { FloatingCTA } from './components/FloatingCTA';
import { PurchasePopup } from './components/PurchasePopup';
import { Hero } from './components/sections/Hero';
import { Promise as PromiseSection } from './components/sections/Promise';
import { BeforeAfter } from './components/sections/BeforeAfter';
import { ForYou } from './components/sections/ForYou';
import { Volumes } from './components/sections/Volumes';
import { Inside } from './components/sections/Inside';
import { Bonuses } from './components/sections/Bonuses';
import { Offer } from './components/sections/Offer';
import { Testimonials } from './components/sections/Testimonials';
import { Guarantee } from './components/sections/Guarantee';
import { Author } from './components/sections/Author';
import { Faq } from './components/sections/Faq';
import { FinalCta } from './components/sections/FinalCta';
import { Footer } from './components/sections/Footer';
export function App() {
  return <div className="w-full overflow-x-hidden bg-ink-900 font-sans text-zinc-100" data-id="element-0" data-mp="3ikqzm1my986s">
      <MetaPixel data-id="element-1" data-mp="3mlayb9n68jv1" />
      <PurchasePopup data-id="element-2" data-mp="3mkrc3gqhn9b7" />

      <main className="w-full" data-id="element-3" data-mp="3mjzsz5e2v41t">
        <Hero data-id="element-4" data-mp="3mj6jvxrnc2gi" />
        <PromiseSection data-id="element-5" data-mp="3rcj5s04xxv5k" />
        <BeforeAfter data-id="element-6" data-mp="3rbzq6q2rjiup" />
        <ForYou data-id="element-7" data-mp="3rcsyhvhdegey" />
        <Volumes data-id="element-8" data-mp="3recf5n6xuth9" />
        <Inside data-id="element-9" data-mp="5yjsutqtdfe" />
        <Bonuses data-id="element-10" data-mp="6hqtghuuhen" />
        <Offer data-id="element-11" data-mp="4wvvprmowg9" />
        <Testimonials data-id="element-12" data-mp="4n7g6m8exco" />
        <Guarantee data-id="element-13" data-mp="82kl3wchwbg" />
        <Author data-id="element-14" data-mp="2zl3brl12165b" />
        <Faq data-id="element-15" data-mp="2zlldgx6hkckm" />
        <FinalCta data-id="element-16" data-mp="2zm4y4lnitf2c" />
      </main>

      <Footer data-id="element-17" data-mp="2zmwguvw0rib7" />
      <FloatingCTA data-id="element-18" data-mp="2zng14j956ise" />
    </div>;
}